// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height[data-v-545e64a2] {\r\n  position: relative;\r\n  height: 100%;\n}\n.el-dialog__body[data-v-545e64a2] {\r\n  padding-top: 0px;\n}\n[data-v-545e64a2] .el-cascader input[type='text']:disabled {\r\n  color: blue !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
